export interface BulkUtilResponse {
    ignoreList: string[];
    emails: string[];
}

export interface BulkMoveCodeResponse {
    codesMoved: string[];
}

export interface BulkDeleteCodeTableRows {
    numOfCodes: number;
    date: Date;
}

export interface BulkCreditRequest {
    service_location_id: number;
    service_plan_id: number | null;
    days: number;
    months: number;
    dollars: number;
}

export interface BulkLocationSelection {
    service_location_id: number;
    service_plan_id?: number;
}

export interface BulkMembershipIdsSelection {
    membership_ids: number[];
}

export interface BulkUserIdsSelection {
    service_location_id: number;
    service_plan_id?: number;
    user_ids: number[];
}

export interface BulkUserEmailsSelection {
    service_location_id: number;
    service_plan_id?: number;
    user_emails: string[];
}

export type BulkMemberSelection =
    | BulkLocationSelection
    | BulkMembershipIdsSelection
    | BulkUserIdsSelection
    | BulkUserEmailsSelection;

export type BulkDiscountRequest = BulkMemberSelection & {
    coupon_id: string;
};

export interface BulkCancelRequest {
    service_location_id: number;
    service_plan_id: number | null;
    when: TerminationSchedule;
    refund_type: RefundType;
}

export enum RefundType {
    none,
    prorated,
    full
}

export enum TerminationSchedule {
    immediately,
    end_of_period
}
